module.exports = __webpack_public_path__ + "img/2_鸟瞰A馆国际及港澳台馆1(1).e325202d.jpg";